import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectOnlineBooking = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('online_booking')(jsonQuery),
);
